<template>
  <div>
    <slot :logout="logout"></slot>
  </div>
</template>
<script>
  import utils from '@/utils'
  import global from '@/config/index.js'
  import logoutService from '@/services/bylBaseCenter/user/logout'
  import { removeCookie } from "@/utils/cookies"
  import { clearAll, listeningToUserActions }  from '@/utils/listeningToUserActions'
  export default {
    methods: {
      logout () {
        removeCookie(this.$vars.TOKEN_KEY)
        removeCookie(this.$vars.USERID_KEY)
        removeCookie('org')
        removeCookie('query_record')
        removeCookie('ifrm_031')
        logoutService.logout().then((r) => {
            if (window.location.hostname == "localhost") {
      window.location.href = "http://localhost:8080";
    } else {
      window.location.href = "https://inesajxjy.byl.sh.cn";
    }
          // window.location.href = 'https://inesajxjy.byl.sh.cn'
        })
        // var isIP = utils.isIP(window.location.hostname);
        // if (!isIP) { // 域名/localhost的情况
        //   if (window.location.hostname == 'localhost') {
        //     window.location.href = 'http://localhost:8080'
        //   } else {
        //     window.location.href = 'http://' + global.DEFAULT_DOMAIN + ':' + global.webport
        //   }
        // } else {
        //   if (global.DEPLOY) {
        //     window.location.href = 'http://' + window.location.hostname
        //   } else {
        //     window.location.href = 'http://' + window.location.hostname + ':' + global.webport
        //   }
        // }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/auth/containerLogout.vue